import { fonts, headerMonthHeight, monthWidth, singleDayWidth, topRowTextYPos } from "../../../constants";
import { Theme } from "../../../styles";
import { Day } from "../../../types/global";
import { daysInYear } from "../../dates";
import { drawRow } from "../../drawRow";
export const drawYearsToMonthOnTop = (
  ctx: CanvasRenderingContext2D,
  startDate: Day,
  dayOfYear: number,
  theme: Theme
) => {
  const yPos = 0;
  const year = startDate.year;
  const canvasWidth = ctx.canvas.width;
  let xPos = 0;
  let index = 0;
  let width = 12 * monthWidth;
  let totalWidthOfElements = 0;

  while (xPos + totalWidthOfElements <= canvasWidth) {
    if (index > 0) {
      width = daysInYear(year + index) * singleDayWidth;
    }

    if (totalWidthOfElements + width > canvasWidth && index > 0) {
      width = Math.ceil((canvasWidth - totalWidthOfElements) / singleDayWidth) * singleDayWidth;
    }

    drawRow(
      {
        ctx,
        x: xPos,
        y: yPos,
        width,
        height: headerMonthHeight,
        textYPos: topRowTextYPos,
        label: (year + index).toString(),
        font: fonts.topRow
      },
      theme
    );

    xPos += width;
    totalWidthOfElements += width;
    index++;
  }
};
